import { Chip } from '@mui/material';
import { useGetOne } from 'ra-core';

export const StudyFormChip = ({ id }: { id: string }) => {
    const { data: studyForm } = useGetOne(
        'studyForm',
        { id },
        { enabled: !!id }
    );

    return <Chip label={studyForm?.title ?? id} size="small" />;
};
